// Left menu
export const LEFT_MENU_USER_MANAGEMENT = 'User Management';
export const LEFT_MENU_ROLE_AND_PERMISSION = 'Role and Permission';
export const LEFT_MENU_REQUESTER = 'Requester';
export const LEFT_MENU_APPROVER = 'Approver';
export const LEFT_MENU_ADMINISTRATION = 'Administration';
export const LEFT_MENU_REQUEST_APPROVAL = 'Request & Approval';
export const LEFT_MENU_DIGITAL_PRICE_TAG = 'Discounted RRP';
export const LEFT_MENU_SUB_UPLOAD_EXCEL_CHAIN_WIDE = 'Upload Excel (Chainwide)';
export const LEFT_MENU_SUB_UPLOAD_EXCEL_ROADSHOW = 'Upload Excel (Roadshow)';
export const LEFT_MENU_SUB_UPLOAD_EXCEL_SELECTED_SHOP = 'Upload Excel (Selected Shop)';
export const LEFT_MENU_EXCEL_UPLOAD_LOG = 'Excel Upload Log';

// Error messages
export const ERROR_INPUT_REQUIRED = 'Input required';
export const ERROR_EMAIL_IS_INVALID = 'Invalid Email';
export const ERROR_PASSWORD_NOT_MATCH = 'Password is not matched';
export const ERROR_PERMISSION_NOT_CHOICE = 'Please select permission!';

export const EDIT_MODEL_CREATE = 'CREATE';
export const EDIT_MODEL_EDIT = 'EDIT';
export const EDIT_MODEL_VIEW = 'VIEW';

//api status
export const API_CALL_STATUS_LOADING = "loading";
export const UPLOAD_EXCEL_SUCCESS = 'Upload Excel Success';
export const UPLOAD_EXCEL_FAIL = 'Upload Excel Fail';

//Upload Excel color message
export const RED = 'Data rejected: update not processed.';
export const YELLOW = 'Data mismatch: update will be processed.';
export const BLACK = 'Data correct: update will be processed.';

// Menu id
export const MENU_CONFIG = {
  "010000": {
    id: "010000",
    name: "Administration",
    defaultAccess: 'View',
    subMenus: ["010100", "010200"]
  },
  "010100": {
    id: "010100",
    name: "User Management",
    accessMap: {
      'View': [4, 5],
      'View and Edit': [1, 2, 4, 5],
      'Full access': [1, 2, 3, 4, 5]
    }
  },
  "010200": {
    id: "010200",
    name: "Roles and Permission",
    accessMap: {
      'View': [9, 10],
      'View and Edit': [6, 7, 9, 10],
      'Full access': [6, 7, 8, 9, 10]
    }
  },

  "030000": {
    id: "030000",
    name: "Discounted RRP",
    defaultAccess: 'View',
    subMenus: ["030100", "030200", "040100", "030300"]
  },
  "030100": {
    id: "030100",
    name: "Upload Excel (Chainwide)",
    accessMap: {
      'View': [14],
      'View and Edit': [14, 15],
      'Full access': [14, 15, 16]
    }
  },
  "030200": {
    id: "030200",
    name: "Upload Excel (Roadshow)",
    accessMap: {
      'View': [17],
      'View and Edit': [17, 19],
      'Full access': [17, 18, 19]
    }
  },
  "040100": {
    id: "040100",
    name: "Upload Excel (Selected Shop)",
    accessMap: {
      'View': [22],
      'View and Edit': [22, 23],
      'Full access': [22, 23, 24]
    }
  },
  "030300": {
    id: "030300",
    name: "Excel Upload Log",
    accessMap: {
      'View': [20, 21],
    }
  }
};
